// ============================================================
// Question Component
// Displays whatever question data comes back from the backend.
// Contains NO question text, NO scoring logic, NO options hardcoded —
// everything comes from the API response.
// ============================================================

import React, { useState, useEffect } from 'react';
import { getQuestion, saveAnswer, submitSession } from '../services/api';

function Question({ sessionId, onComplete }) {
  const [questionNumber, setQuestionNumber] = useState(1);
  const [questionData, setQuestionData] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    loadQuestion(questionNumber);
  }, [questionNumber]);

  async function loadQuestion(num) {
    setLoading(true);
    try {
      const data = await getQuestion(sessionId, num);
      setQuestionData(data);
      setSelectedKey(data.previousAnswer || null); // pre-fill if already answered
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  async function handleSelect(key) {
    setSelectedKey(key);
    await saveAnswer(sessionId, questionNumber, key); // overwrites if changing
  }

  function goNext() {
    if (questionNumber < 20) {
      setQuestionNumber(questionNumber + 1);
    } else {
      handleFinalSubmit();
    }
  }

  function goPrevious() {
    if (questionNumber > 1) {
      setQuestionNumber(questionNumber - 1);
    }
  }

  async function handleFinalSubmit() {
    const result = await submitSession(sessionId);
    if (result.error) {
      setSubmitError(result.message);
    } else {
      onComplete(sessionId);
    }
  }

  if (loading || !questionData) return <div>Loading question...</div>;

  return (
    <div className="question">
      <div className="progress">Question {questionNumber} of {questionData.totalQuestions}</div>

      <p className="question-text">{questionData.text}</p>

      <div className="options">
        {questionData.options.map(opt => (
          <label key={opt.key} className={selectedKey === opt.key ? 'selected' : ''}>
            <input
              type="radio"
              name="answer"
              checked={selectedKey === opt.key}
              onChange={() => handleSelect(opt.key)}
            />
            {opt.label}
          </label>
        ))}
      </div>

      {submitError && <p className="error">{submitError}</p>}

      <div className="nav-buttons">
        <button onClick={goPrevious} disabled={questionNumber === 1}>
          Previous
        </button>
        <button onClick={goNext} disabled={!selectedKey}>
          {questionNumber === 20 ? 'Submit' : 'Next'}
        </button>
      </div>
    </div>
  );
}

export default Question;
